// --- FILE: packages/components/src/quotes/QuoteListItem.tsx ---

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Badge, Button } from '@dopomogai/ui';
import type { BadgeAccentColor } from '@dopomogai/ui';
import type { QuoteSummary } from '@dopomogai/types';

type Props = {
  quote: QuoteSummary;
};

export function QuoteListItem({ quote }: Props) {
  const navigate = useNavigate();

  const getStatusProps = (): { text: string; color: BadgeAccentColor; actionText: string } => {
    switch (quote.status) {
      case 'paid':
        return { text: 'Paid', color: 'green', actionText: 'View Receipt' };
      case 'expired':
        return { text: 'Expired', color: 'yellow', actionText: 'View Details' };
      case 'pending':
      default:
        return { text: 'Pending', color: 'blue', actionText: 'Pay Now' };
    }
  };
  
  const { text, color, actionText } = getStatusProps();

  const handleClick = () => {
    navigate(`/quotes/${quote.id}`);
  };

  return (
    <Card noHoverEffect className="mb-4">
      <div className="flex items-center justify-between gap-4 p-4">
        <div>
          <p className="font-bold text-slate-800">{quote.agent_name || 'Custom Agent'}</p>
          <p className="text-sm text-slate-500">
            Created on {new Date(quote.created_at).toLocaleDateString()}
          </p>
        </div>
        <div className="flex items-center gap-6">
          <span className="font-mono text-lg font-semibold">
            ${quote.setup_usd.toLocaleString()}
          </span>
          <Badge text={text} accentColor={color} />
          <Button variant="secondary" onClick={handleClick}>{actionText}</Button>
        </div>
      </div>
    </Card>
  );
}